import { useContextState } from '../../../../../../../../hooks/theme'

const useStyles = () => {
  const { colors } = useContextState()

  return {
    container: {
        padding:'50px 100px'
    },
    subContaine: {
        maxWidth:'550px',
        display:'flex',
        flexDirection:'column',
        gap:2
    },
    checkBox: { 
        padding: '0px' 
    },
    frequency: {
        display:'flex', 
        gap:1,
        alignItems:'center'
    },
    timePicker: {
        maxWidth:'210px',
    },
    saveButon: {
        display:'flex',
        justifyContent:'end'
    },
  }
}

export { useStyles }